import SectionTitle from '@/components/base/SectionTitle';
import { testimonials } from '@/mocks/site';

export default function TestimonialsSection() {
  return (
    <section id="voices" className="w-full border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionTitle
          eyebrow="Reader Voices"
          title="他们说，吃瓜终于有了依据"
          desc="来自读者、教师和品牌从业者的反馈。我们把它放在这里，也当作对自己的提醒。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item, index) => (
            <figure
              key={item.name}
              className={`flex h-full flex-col rounded-xl border p-6 ${
                index === 1
                  ? 'border-accent-300 bg-accent-50'
                  : 'border-background-200 bg-background-100/60'
              }`}
            >
              <i className={`ri-double-quotes-l text-2xl ${index === 1 ? 'text-accent-500' : 'text-primary-400'}`}></i>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-800">{item.quote}</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-foreground-950 font-heading text-sm font-bold text-background-50">
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="font-heading text-sm font-semibold text-foreground-950">{item.name}</span>
                  <span className="font-label text-xs text-foreground-600">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}